import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["disabled"]

import { Form } from 'vee-validate';
import InputCheckbox from '@/shared/form/InputCheckbox.vue';
import InputErrorMessage from '@/shared/form/InputErrorMessage.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useCustomerOffer } from './useCustomerOffer';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { HtmlString } from '@/types/B2CcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketActionOfferConcentAccept',
  props: {
    agreeConsentCheckboxText: null
  },
  emits: ['success'],
  setup(__props: any, { emit }) {

const props = __props as {
    agreeConsentCheckboxText: HtmlString;
}




const { acceptCustomerOfferConsentRequest } = useCustomerOffer();
const consentId = useRouteQuery(QueryKeys.Id);
const labels = useBlockLabels();
const consentMessageId = 'consentMessageIdTest';

const formValidation = {
    consent: 'required',
};

const consentSubmit = async(): Promise<void> => {
    await acceptCustomerOfferConsentRequest(consentId.value, consentMessageId);
    emit('success');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(Form), {
        "validation-schema": formValidation,
        onSubmit: consentSubmit
      }, {
        default: _withCtx(({ isSubmitting }) => [
          _createVNode(InputCheckbox, {
            name: "consent",
            class: "pt-24",
            "show-errors": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: props.agreeConsentCheckboxText
              }, null, 8, _hoisted_1),
              _createVNode(InputErrorMessage, {
                class: "mt-5",
                name: "consent"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "c-button c-button--primary min-w-120 mt-24",
              disabled: isSubmitting
            }, _toDisplayString(_unref(labels).submitConsentButtonText), 9, _hoisted_2)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(WebApiMessage, {
      id: consentMessageId,
      "clear-timing": 10000,
      class: "mt-30"
    })
  ], 64))
}
}

})